module.exports = __webpack_public_path__ + "media/images/LearnMore31-50ccfd2c7c88299d2f4ee893ef330778.png";